import React from 'react';
import { Button, Input, Modal, Select, Space, Table, Tag } from 'antd';
import { formatDate } from 'utils/date';

const columns = [
  {
    title: 'Shop',
    sorter: (a, b) => new Date(a?.create_on || 0) - new Date(b?.create_on || 0),
    defaultSortOrder: 'descend',
    render: (_, record) => (
      <>
        <div>
          <Space>
            {record?.web_site?.title}
            {record?.is_demo || record?.shop_type === 'demo' ? <Tag color='blue'>Demo</Tag> : null}
            <a href={`https://${record?.web_site?.url}.sipro.store`} target='_blank' rel='noreferrer'>Xem</a>
          </Space>
        </div>
        <div>{formatDate(record?.create_on)}</div>
      </>
    ),
  },
  {
    title: 'Liên hệ',
    render: (_, record) => (
      <>
        <div>
          <Space>
            {record?.owner?.phone}
            {record?.owner?.full_name}
          </Space>
        </div>
      </>
    ),
  },
  {
    title: 'Chỉ số',
    render: (_, record) => (
      <>
        <div>Sản phẩm: {record?.product_count || 0}</div>
        <div>Đơn tháng này: {record?.order_count_month || 0}</div>
      </>
    ),
  },
];

const Desktop = ({ viewModel }) => {
  const {
    filteredData,
    keyword,
    onKeywordChange,
    packageFilter,
    onPackageFilterChange,
    expiryFilter,
    onExpiryFilterChange,
    getPackageName,
    openRenewModal,
    renewTarget,
    packages,
    renewPackageKey,
    setRenewPackageKey,
    renewDuration,
    setRenewDuration,
    renewSubmitting,
    closeRenewModal,
    submitRenew,
    createDemoOpen,
    createDemoShopName,
    createDemoSubmitting,
    createDemoResult,
    openCreateDemoModal,
    closeCreateDemoModal,
    onCreateDemoShopNameChange,
    submitCreateDemo,
    closeCreateDemoResult,
    copyText,
    copyAllCredentials,
    goToDetail,
  } = viewModel;

  const tableColumns = [
    ...columns,
    {
      title: 'Gói cước',
      render: (_, record) => (
        <>
          <div>
            <Space>
              {getPackageName(record)}
              {getPackageName(record) === 'invalidate' ? <Tag color='red'>Invalidate</Tag> : null}
            </Space>
          </div>
          {record?.subscription?.tier && record?.subscription?.tier !== 'mien_phi' && (
            <div>Hết hạn: {formatDate(record?.subscription?.expiry_on) || '-'}</div>
          )}
        </>
      ),
    },
    {
      title: 'Thao tác',
      render: (_, record) => (
        <Space>
          <Button onClick={() => goToDetail(record.id)}>Xem thông tin</Button>
          <Button onClick={() => openRenewModal(record)}>Gia hạn</Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <Space wrap>
        <Input
          placeholder='Tìm theo shop, domain, chủ shop, số điện thoại'
          allowClear
          value={keyword}
          onChange={onKeywordChange}
          style={{ width: 420 }}
        />
        <Select value={packageFilter} style={{ width: 200 }} onChange={onPackageFilterChange}>
          <Select.Option value='all'>Tất cả gói</Select.Option>
          {(packages || []).map((item) => (
            <Select.Option key={item.key} value={item.key}>{item.name}</Select.Option>
          ))}
        </Select>
        <Select value={expiryFilter} style={{ width: 220 }} onChange={onExpiryFilterChange}>
          <Select.Option value='all'>Tất cả hạn dùng</Select.Option>
          <Select.Option value='expiring_7d'>Sắp hết hạn (7 ngày)</Select.Option>
        </Select>
      </Space>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button type='primary' onClick={openCreateDemoModal}>Tạo shop demo nhanh</Button>
      </div>

      <Table rowKey={(record) => record.id || record._id || record?.web_site?.url} columns={tableColumns} dataSource={filteredData} />

      <Modal
        title='Gia hạn gói cước'
        open={!!renewTarget}
        onCancel={closeRenewModal}
        onOk={submitRenew}
        okText='Xác nhận gia hạn'
        cancelText='Đóng'
        confirmLoading={renewSubmitting}
      >
        <Space direction='vertical' style={{ width: '100%' }}>
          <div>Shop: {renewTarget?.web_site?.title || '-'}</div>
          <div>
            <label>Gói cước</label>
            <Select value={renewPackageKey} style={{ width: '100%' }} onChange={setRenewPackageKey}>
              {(packages || []).map((item) => (
                <Select.Option key={item.key} value={item.key}>{item.name}</Select.Option>
              ))}
            </Select>
          </div>
          <div>
            <label>Số tháng</label>
            <Select value={renewDuration} style={{ width: '100%' }} onChange={setRenewDuration}>
              <Select.Option value={1}>1 tháng</Select.Option>
              <Select.Option value={3}>3 tháng</Select.Option>
              <Select.Option value={6}>6 tháng</Select.Option>
            </Select>
          </div>
        </Space>
      </Modal>

      <Modal
        title='Tạo shop demo nhanh'
        open={createDemoOpen}
        onCancel={closeCreateDemoModal}
        onOk={submitCreateDemo}
        okText='Tạo shop'
        cancelText='Đóng'
        confirmLoading={createDemoSubmitting}
      >
        <Input
          placeholder='Nhập tên shop'
          value={createDemoShopName}
          onChange={onCreateDemoShopNameChange}
          maxLength={120}
        />
      </Modal>

      <Modal
        title='Thông tin đăng nhập shop demo'
        open={!!createDemoResult}
        onCancel={closeCreateDemoResult}
        footer={[
          <Button key='copy' onClick={copyAllCredentials}>Copy tất cả</Button>,
          <Button key='close' type='primary' onClick={closeCreateDemoResult}>Đóng</Button>,
        ]}
      >
        <Space direction='vertical' style={{ width: '100%' }}>
          <div>
            Shop URL: <a href={`https://${createDemoResult?.shop_url}.sipro.store`} target='_blank' rel='noreferrer'>{`https://${createDemoResult?.shop_url}.sipro.store`}</a>
          </div>
          <Space>
            Username: {createDemoResult?.username || '-'}
            <Button size='small' onClick={() => copyText(createDemoResult?.username, 'username')}>Copy</Button>
          </Space>
          <Space>
            Login ID: {createDemoResult?.login_id || '-'}
            <Button size='small' onClick={() => copyText(createDemoResult?.login_id, 'login id')}>Copy</Button>
          </Space>
          <Space>
            Password: {createDemoResult?.password || '-'}
            <Button size='small' onClick={() => copyText(createDemoResult?.password, 'mật khẩu')}>Copy</Button>
          </Space>
          <div>Workspace ID: {createDemoResult?.w_id || '-'}</div>
        </Space>
      </Modal>
    </div>
  );
};

export default Desktop;